import React from "react";
import {useFormik} from "formik";
import {IntrApiPut} from "./intr_api";
import * as yup from "yup";
import {Box, Button, CardActions, CardContent, FormControl, FormControlLabel, Switch, TextField} from "@mui/material";


interface IntrFormProps {
    onSubmit: (values: IntrApiPut) => void
    onCancel: () => void
    object: IntrApiPut,
    isUpdating: boolean,

}

const IntrSchema = yup.object().shape({

    Code: yup.string().min(2).max(40).required(),
    Name: yup.string().required(),
    Timeout: yup.number().min(0).max(60),
    Active: yup.boolean().required(),
})

export default ({object, onSubmit, onCancel, isUpdating}: IntrFormProps) => {
    const formik = useFormik<IntrApiPut>({
        initialValues: object,
        onSubmit: onSubmit,
        validationSchema: IntrSchema
    });


    return <Box component={"form"} className={"form-100"} onSubmit={formik.handleSubmit}>
        <CardContent>
            <TextField
                name={"Code"}
                id={"Code"}
                value={formik.values.Code}
                label={"Koda"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.Code && Boolean(formik.errors.Code)}
                helperText={formik.touched.Code && formik.errors.Code}
            />
            <TextField
                name={"Name"}
                id={"Name"}
                value={formik.values.Name}
                label={"Ime za prikaz"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}

                error={formik.touched.Name && Boolean(formik.errors.Name)}
                helperText={formik.touched.Name && formik.errors.Name}
            />
            <TextField
                name={"Timeout"}
                id={"Timeout"}
                type={"number"}
                value={formik.values.Timeout}
                label={"Samodejno zaključi [minut]"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.Timeout && Boolean(formik.errors.Timeout)}
                helperText={formik.touched.Timeout && formik.errors.Timeout}
            />
            <FormControl>
                <FormControlLabel label={"Active"} control={<Switch
                    id={"Active"}
                    name={"Active"}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    checked={formik.values.Active}
                />}/>
            </FormControl>


        </CardContent>
        <CardActions>
            <Button disabled={isUpdating} type={"submit"}>Shrani</Button>
            <Button onClick={onCancel}>Prekliči</Button>
        </CardActions>
    </Box>

}
